import { makeStyles } from "@fluentui/react-components";

export const usePassengerIconStyles = makeStyles({
    root: {
        fill: '#FFFFFF',
    }
});